export const reducedMotion = 'reducedMotion';

export const isReducedMotion = `.reducedMotion &`;
